import { useLayoutEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { EAdvancedEventsLayouts } from 'interfaces/sportsbook';
import { addQuery } from 'components/QueryRoute';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import { useSearchParams } from 'hooks/useSearchParams';

export const useAdvancedInitialRedirection = () => {
  const history = useHistory();
  const isInitialMountRef = useRef(true);
  const configs = useSportsbookConfigs();

  const { layoutType, coupon, filterBy, viewBy } = useSearchParams();

  useLayoutEffect(() => {
    if (
      !SpringConfigs.MOCKED_DATA &&
      isInitialMountRef.current &&
      configs.type === 'live' &&
      !layoutType &&
      !coupon &&
      !filterBy &&
      !viewBy
    ) {
      isInitialMountRef.current = false;

      history.push(addQuery({ layoutType: EAdvancedEventsLayouts.live }));
    }
  }, [layoutType]);
};
